import React from 'react'
import DynamicFormElements from '../Form/DynamicFormElements'

const formConfigTemplate = [
    {
        type: 'articleSelect',
        name: 'articleIDs'
    },
    {
        type: 'checkbox',
        name: 'includeAllArticlesOfMandator',
        label: 'dispolistIncludeAllArticlesOfMandator'
    },
    {
        type: 'text',
        name: 'mailAddress',
        label: 'emailAddress'
    }
]

const ArticleExport = ({ formData, setFormData, formErrors }) => {

    return (
        <>
            <DynamicFormElements formConfigTemplate={formConfigTemplate} setFormData={setFormData} formData={formData} formErrors={formErrors} />
        </>
    )
}
export default ArticleExport